import React, {useEffect, useState} from 'react';
import { useSelector , useDispatch} from 'react-redux';
import {
  Grid, Button, Stack, Box, Card, CardHeader,CardContent,CardActions,
  Paper, Typography,  Radio,FormControlLabel, IconButton, TextField, FormControl, RadioGroup,
} from '@mui/material';


import {  useParams, useNavigate } from "react-router-dom";
//import Box from '@mui/material/Box';

import {usePlayContext} from '../utils/PlayContext';

import {  
          cancelApplication,

          selectApplicationById,
          hardDeleteApplication,
          selectApplicationError} from '../store/applicationSlice' 


const ApplyCancelPageInternal = ({invitation, action})=>
{
    const [deleteMode, setDeleteMode] = useState('once')
  
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const {
      setOp,
      status, setStatus,  
      setErrorMessage, setErrorTitle,
      openSnackToast,
    }=usePlayContext()


  const [cancelReason, setCancelReason] = useState('');

  
  const  doProceed= async()=>
  {
      setStatus('processing')

      try
      {

        let xxx = 
        {
          id:   invitation.id,
          operation:'cancel',
          hardDelete: 'Delete'===action,
          reason:cancelReason,
          cancelAllReoccurances : deleteMode !=='once'
        }


        if (action==='Cancel')
        {
          let www = await dispatch(cancelApplication(xxx)).unwrap()
        }
        else if (action==='Delete')
        {
          let www = await dispatch(hardDeleteApplication(xxx)).unwrap()
        }
        setStatus('idle')
        setOp('')

        if (action==='Cancel')
        {
          navigate('/invitations')
        }
        else if (action==='Delete')
        {
          navigate('/invitations')
        }
        

        let message = "The "+(deleteMode ==='once' ? "invitation has":"entire series of invitations have") +" been "+(action==='Cancel'?"cancelled":"permanently deleted.")
        openSnackToast(message)
      }
      catch (ex)
      {
          setStatus('error')
          setErrorMessage('Error occured')
      }

  }

  const onDeleteModeChanged = (value)=>
  {
      setDeleteMode(value)
  }


  return (
    
    <Box sx={{p:1}}>
      <Card raised sx={{border:1}}>
          <CardHeader disableTypography
              sx={{ }}
              title={ 
                <Typography variant='h5'>
                  {action+' Invitation'+"  ["}
                  <string>{invitation.reason}</string>]
                </Typography>   
              }
              subheader={  
                <Typography variant='body2'><small>{
                  invitation.reoccurenceId && invitation.reoccurenceMessage ?
                  invitation.reoccurenceMessage:'one-time invitation'}</small></Typography> 
              }
              >
          </CardHeader>
          <CardContent sx={{mx:1, border:0}}>
            <Stack spacing={2} sx={{alignItems:'center'}}>
              { invitation.reoccurenceId && 
              <FormControl sx={{ bgcolor:'@@red'}}>
                        <RadioGroup
                                size='small'
                                row
                                onChange={event => onDeleteModeChanged(event.target.value)}
                                value={deleteMode}
                                >
                            <FormControlLabel 
                                size='small'
                                sx={{ mr:{xs:5, sm:8, md:12}}}
                                value="once" control={<Radio />} 
                                label={action+" Once"} />

                            {(invitation.status!=='CANCELLED')?
                            (<FormControlLabel 
                              size='small'
                              value="reoccurence" control={<Radio />} 
                              label={action+" Whole Series"} />) :
                              (<FormControlLabel 
                                size='small'
                                value="reoccurence" control={<Radio />} 
                                label={action+" All Cancelled Invitation in Series"} />) 
                            }
                           
                           
                        </RadioGroup>
                    </FormControl>
            }
            <TextField 
                //required
                size='small'
                fullWidth
                //error={Boolean(subjectError)}
                value={cancelReason}
                id="id_cancel_reason" 
                label={  "Purpose to "+action+" Invitation"} 
                onChange = { e=>setCancelReason(e.target.value)}
                inputProps={{ maxLength: 100, minLength:5 }}
                helperText={  "Purpose to "+action +" Invitation (optional)"}/>
            </Stack>
          </CardContent>
          <CardActions>
            <Box sx={{display:'flex', width:'100%', justifyContent: 'space-around'}}>
              <Button variant="outlined"size='small' 
                  sx={{textTransform:'none'}}

                //disabled={!Boolean(cancelReason)}
                onClick={doProceed}
                >Proceed to {action}</Button>
              <Button variant="outlined"size='small' 
					//color='error'
                  sx={{textTransform:'none'}}
                onClick={(e)=>{navigate(-1)}}
              >Back</Button>
            </Box>
          </CardActions>

      </Card>
    </Box>

  )

}

const ApplyCancelPage = ({action})=>
{
  const {id}=useParams();
  const invitation = useSelector(selectApplicationById(id))


  console.log("KKKKKKKKKKKKKKKKKKKKKKKKKKKKKKK")
  console.log(invitation)

  const {
    setOp,
    status, setStatus, appTitle, setAppTitle, 
    errorMessage, setErrorMessage, errorTitle, setErrorTitle,
    openSnackToast,

  }=usePlayContext()

  useEffect(() =>{
    setAppTitle( ['Invitations', action+' Details', invitation.reason+ " (ref#-"+invitation.id+")"])
    setErrorMessage('')
    setErrorTitle('')
    setOp('')
    
    
    //doFetchApplications(id)
    return ()=>{
      setErrorMessage('')
      setErrorTitle('')
      setOp('')
    }

    }, [ ])

  return (
    <React.Fragment>
    {
      (Boolean(id) && Boolean(invitation)) &&
        <ApplyCancelPageInternal invitation={invitation} action={action} />
    }
    <Stack/>
    </React.Fragment>
  )
}

export default ApplyCancelPage;
